var _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _circle4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGamingPad(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 42H18.5L17.3219 43.885C16.4996 45.2007 15.0574 46 13.5059 46H6C3.79086 46 2 44.2091 2 42Z",
    fill: "#7617DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54 42H38L39.1105 43.8324C39.9261 45.1781 41.3854 46 42.9589 46H50C52.2091 46 54 44.2091 54 42Z",
    fill: "#7617DB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8784 10H32.1216C39.0968 10 42.5843 10 45.3218 11.3146C47.732 12.4721 49.7346 14.3266 51.0672 16.6351C52.5807 19.2571 52.8291 22.7169 53.3261 29.6365L53.9799 38.7398C54.3005 43.2033 50.746 47 46.2466 47C43.9456 47 41.7635 45.9835 40.2905 44.2255L39.2936 43.0357C38.3818 41.9475 37.9257 41.4032 37.4066 40.9636C36.3182 40.0418 35.0007 39.4281 33.592 39.1866C32.92 39.0714 32.2078 39.0714 30.7834 39.0714H25.2166C23.7922 39.0714 23.08 39.0714 22.408 39.1866C20.9993 39.4281 19.6817 40.0418 18.5934 40.9636C18.0742 41.4033 17.6183 41.9474 16.7064 43.0357L15.7095 44.2255C14.2365 45.9835 12.0544 47 9.75344 47C5.25402 47 1.69953 43.2033 2.0201 38.7398L2.67389 29.6365C3.17085 22.7169 3.41933 19.2571 4.93284 16.6351C6.26542 14.3266 8.26796 12.4721 10.6782 11.3146C13.4157 10 16.9032 10 23.8784 10Z",
    stroke: "#131A29",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 25.5H23M17.5 20V31",
    stroke: "#7617DB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 20.5,
    r: 1.5,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 30.5,
    r: 1.5,
    fill: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 25.5,
    r: 1.5,
    transform: "rotate(-90 35.5 25.5)",
    fill: "black"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 25.5,
    r: 1.5,
    transform: "rotate(-90 45.5 25.5)",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamingPad);
export default __webpack_public_path__ + "static/media/gaming-pad.17e3ca5afd8081acaddbf43e5ca24480.svg";
export { ForwardRef as ReactComponent };